import { PatientNotesState } from './types';
import { PatientNotesTypeAction } from './actions';
import { setAsyncData } from '../core';

const initialState: PatientNotesState = {
  data: {},
};

export function patientNotesReducer(state: PatientNotesState = initialState, action: PatientNotesTypeAction): PatientNotesState {
  switch (action.type) {
    case 'PATIENT_NOTES_SET_NOTES_FETCHING':
      return {
        data: {
          ...state.data,
          [action.data.patientId]: setAsyncData(state.data[action.data.patientId] || { isFetching: false }, (p) => (p.isFetching = action.data.fetching)),
        },
      };

    case 'PATIENT_NOTES_SET_NOTES':
      return {
        data: {
          ...state.data,
          [action.data.patientId]: setAsyncData(state.data[action.data.patientId] || { isFetching: false }, (p) => (p.data = action.data.notes)),
        },
      };

    case 'PATIENT_NOTES_SET_NOTE':
      return {
        data: {
          ...state.data,
          [action.data.patientNote.patientId]: setAsyncData(state.data[action.data.patientNote.patientId] || { isFetching: false }, (p) => {
            p.data = p.data!.slice();
            const index = p.data.findIndex((note) => note.id === action.data.patientNote.id);
            if (index > -1) {
              p.data[index] = action.data.patientNote;
            } else {
              p.data.unshift(action.data.patientNote);
            }
          }),
        },
      };

    case 'PATIENT_NOTES_DELETE_NOTE':
      return {
        data: {
          ...state.data,
          [action.data.patientNote.patientId]: setAsyncData(state.data[action.data.patientNote.patientId] || { isFetching: false }, (p) => {
            p.data = p.data!.slice();
            const index = p.data.findIndex((note) => note.id === action.data.patientNote.id);
            if (index > -1) {
              p.data.splice(index, 1);
            }
          }),
        },
      };

    default:
      return state;
  }
}
